import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import { GlgTooltip } from 'SharedComponents'
import { FaIcon } from '../../../shared/components'

const { Addon } = InputGroup

const Search = ({ value, onChange, disabled }) => {
  const inputRef = useRef(null)

  const [searchValue, setSearchValue] = useState(value)

  useEffect(() => {
    onChange('leagueName', searchValue)
  }, [searchValue, onChange])

  useEffect(() => {
    setSearchValue(value)
  }, [value])

  const handleChange = (event) => {
    const value = event.target.value
    setSearchValue(value)
  }

  const handleReset = () => {
    onChange('leagueName', '')
    setSearchValue('')
    inputRef.current.focus()
  }

  return (
    <FormGroup className="filter btsp_filter">
      <GlgTooltip
        tooltip={!window.I18n ? '' : window.I18n.t('customer_directories.filters.search_tooltip')}
        placement="bottom"
      >
        <InputGroup>
          <FormControl
            type="text"
            value={searchValue}
            placeholder={!window.I18n ? '' : window.I18n.t('customer_directories.filters.search_placeholder')}
            onChange={handleChange}
            inputRef={inputRef}
            readOnly={disabled}
          />
          <Addon>
            <a onClick={handleReset} className="clickable">
              <FaIcon icon="eraser" />
            </a>
          </Addon>
        </InputGroup>
      </GlgTooltip>
    </FormGroup>
  )
}

Search.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Search
